import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { pillars, volumes, volumeIncludes } from '../data/volumes';
export function Volumes() {
  return <section aria-label="System contents" className="bg-transparent" data-id="element-259" data-mp="1845bcd7ch719">
      <div className="mx-auto max-w-6xl px-5 py-12" style={{
      paddingTop: '19px',
      paddingBottom: "21px"
    }} data-id="element-260" data-mp="181skfajlzmc2">
        <div className="text-center" data-id="element-261" data-mp="1zvb1q1x9jqdc">
          <p className="text-xs font-bold uppercase tracking-[0.25em] text-blush" data-id="element-262" data-mp="1zwcq183ai9d0">
            100+ AI PROMPTS FOR THERAPISTS & COUNSELORS: THE SYSTEM
          </p>
          <h2 className="mt-3 font-display text-3xl font-black text-plum sm:text-4xl" data-id="element-263" data-mp="1qumx1xtrf2d4">
            📚 The 6-Volume Clinician Toolkit
          </h2>
          <div className="mt-6 flex flex-wrap justify-center gap-2" data-id="element-264" data-mp="1vrwm3cd8lc0f">
            {pillars.map(p => <span key={p} className="rounded-full border border-grape/25 bg-lilac-soft px-3 py-1 text-xs font-bold uppercase tracking-wide text-grape-deep" data-id="element-265" data-mp="feeuhwebvr1g">
                {p}
              </span>)}
          </div>
        </div>

        <div className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-266" data-mp="3oa9c0v1o1jcs">
          {volumes.map((t, i) => <motion.article key={t.n} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.3,
          delay: i % 3 * 0.05,
          ease: [0.23, 1, 0.32, 1]
        }} className="rounded-2xl border border-grape/15 bg-white p-5" style={{
          paddingTop: "10px",
          paddingBottom: "8px"
        }} data-id="element-267" data-mp="3jb6hi4jbavj2" data-mpi={i}>
              <div className="flex items-center gap-3" data-id="element-268" data-mp="kqoek4onkl86">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-plum font-display text-lg font-black text-white" data-id="element-269" data-mp="fs3dy45hnzj7">
                  {String(t.n).padStart(2, '0')}
                </span>
                <h3 className="text-sm font-bold leading-tight text-plum" data-id="element-270" data-mp="pru8u6xyogjt">
                  <span aria-hidden="true" data-id="element-271" data-mp="wuinle04pga8">{t.emoji} </span>
                  {t.title}
                </h3>
              </div>
              <p className="mt-3 text-sm leading-relaxed text-plum/65" data-id="element-272" data-mp="11tlruw8abih5">{t.desc}</p>
            </motion.article>)}
        </div>

        <div className="mt-10 rounded-2xl border border-grape/25 bg-white p-6" data-id="element-273" data-mp="16pu687enr7n9">
          <p className="text-center font-display text-lg font-black text-grape" data-id="element-274" data-mp="1bk6owf8b8exy">
            ✅ Every Volume includes:
          </p>
          <ul className="mt-5 grid gap-3 sm:grid-cols-2" data-id="element-275" data-mp="1kjbntmnsaaan">
            {volumeIncludes.map(item => <li key={item} className="flex items-start gap-2 text-sm text-plum/75" data-id="element-276" data-mp="1klekuqnct3ov">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-grape" strokeWidth={3} data-id="element-277" data-mp="1pj6cdjk36nsj" />
                {item}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}